var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 219,
    viewBox: "0 0 244 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 244,
    height: 219
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.17 0H0V219H243.17V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.67 97.5V73.5V37.5H101.67V5.5H185.67V97.5M69.67 73.5L69.5 5.5H5.5V213.5H69.5V185.5H113.67M121.67 129.5H101.67V101.5M9.5 129.5H69.67M37.5 33.5V97.5H69.67V69.33H125.67V89.5M121.67 157.5H37.5V181.5M185.67 193.5V213.5H97.67M237.67 213.38L206.56 182.27M169.79 113.5C187.46 113.5 201.79 127.83 201.79 145.5M217.79 145.5C217.79 172.01 196.3 193.5 169.79 193.5C143.28 193.5 121.79 172.01 121.79 145.5C121.79 118.99 143.28 97.5 169.79 97.5C196.3 97.5 217.79 118.99 217.79 145.5Z",
    stroke: "#134263",
    strokeWidth: 11,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243.17,
    height: 219,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityManagementIcon);
export default __webpack_public_path__ + "static/media/community-management-icon.b0c03b23f94ad04c6229f780f13ad0e4.svg";
export { ForwardRef as ReactComponent };